import React from "react";
import ClientMenu from "../../components/clientMenu/ClientMenu";
import ClientCategoriesTable from "../../components/clientCategoriesTable/ClientCategoriesTable";

const CustomerCategories = () => {
  return (
    <>
      <ClientMenu>
        <ClientCategoriesTable />
      </ClientMenu>
    </>
  );
};

export default CustomerCategories;
